export enum ImportedInvoicesTableAccessor {
  FileName = 'fileName',
  IntegrationStatus = 'integrationStatus',
  UploadDate = 'uploadDate',
}
